import { useTranslation } from 'react-i18next';
import { FieldLabel } from '@/components/editorial';
import { resolveMsg, msg, type TKey } from '@/i18n/msg';
import { FilterChips } from '@/components/common/FilterChips';
import {
  WHEN_OPTIONS,
  type CommunityFilters,
  type CommunityWhen,
} from '@/lib/community-display';

/**
 * The group inside the Community toolbar popover (2026-09-10 rebuild).
 * Replaces the two chip rows (categories, diagnoses) that stood above the
 * feed and the "My Posts" button beside them. Date is the only axis the feed
 * narrows on. The "Show: Everyone / Only my notes" group left with the
 * family composer (#2174).
 */
interface CommunityFilterPanelProps {
  filters: CommunityFilters;
  onChange: (f: CommunityFilters) => void;
}

function Group({ id, label, children }: { id: string; label: string; children: React.ReactNode }) {
  return (
    <div role="group" aria-labelledby={id} className="space-y-2">
      <FieldLabel id={id} as="span">{label}</FieldLabel>
      {children}
    </div>
  );
}

export function CommunityFilterPanel({ filters, onChange }: CommunityFilterPanelProps) {
  const { t } = useTranslation('community');
  const options = <V extends string>(list: readonly { value: V; labelKey: TKey }[]) =>
    list.map((o) => ({ value: o.value, label: resolveMsg(t, msg(o.labelKey)) }));
  return (
    <>
      <Group id="community-filter-when" label={t('filter.when.label')}>
        <FilterChips
          value={filters.when}
          onChange={(v) => onChange({ ...filters, when: v as CommunityWhen })}
          options={options(WHEN_OPTIONS)}
        />
      </Group>
    </>
  );
}
